




















































// 批量加载覆盖层模版
const requireComponent = require.context(
  "./templates",
  true,
  /\w+\.(vue)$/,
  "lazy",
);
// 处理懒加载
const promisedOverlayComponets = requireComponent
  .keys()
  .reduce((result, fileName) => {
    const dirNameArray = fileName.split("/").reverse();
    const componentName =
      dirNameArray[0] == "index.vue"
        ? dirNameArray[1]
        : dirNameArray[0].split(".")[0];
    const promisedComponent = requireComponent(fileName)
      .then((componentConfig: any) => {
        return componentConfig.default || componentConfig;
      })
      .catch((error: any) => {
        console.log(error);
        return;
      });
    return {
      ...result,
      ...{
        [componentName]: () => promisedComponent,
      },
    };
  }, {});

import Vue from "vue";
import Component from "vue-class-component";
import ResizeMove from "../../../components/Com.ResizeMove/index.vue";
import { REMOVE_CHART_OVERLAY_BY_ID } from "../../../store/chart-overlay.module/mutations/remove-chart-overlay-by-id.mutation";
import { SET_ACTIVE_OVERLAY } from "../../../store/chart-overlay.module/mutations/set-active-overlay.mutation";
import { RESET_ACTIVE_OVERLAY } from "../../../store/chart-overlay.module/mutations/reset-active-overlay.mutation";
import ResizeMoveLine from "../../../components/Com.Line/index.vue";
import { OverlayRenderType } from "../../../../shared/types/layout-workspace/components/chart-overlay/enums/overlay-render-type.enum";
import { ChartOverlayMetadata } from "../../../../shared/types/layout-workspace/components/chart-overlay/chart-overlay-metadata.interface";
import { VuexModuleName } from "../../../../shared/types/vuex/enums/module-name.enum";
import { UPDATE_CHART_OVERLAY } from "../../../store/chart-overlay.module/mutations/update-chart-overlay.mutation";
import { Rect } from "../../../../shared/types/layout-workspace/components/resize-move/reszie-move.interface";

@Component({
  components: {
    ResizeMove,
    ResizeMoveLine,

    ...promisedOverlayComponets,
  },
  mixins: [],
})
export default class Overlay extends Vue {
  // Computed
  // ===================================================================
  get overlayMetadataList(): Array<ChartOverlayMetadata> {
    return this.$stock.state[VuexModuleName.CHART_OVERLAY].metadataList;
  }

  get activeOverlayId(): string | undefined {
    return this.$store.state[VuexModuleName.CHART_OVERLAY].activeOverlayId;
  }

  get resizeMoveList(): Array<ChartOverlayMetadata> {
    return this.overlayMetadataList.filter(
      ({ render }) => render === OverlayRenderType.RESIZE_MOVE,
    );
  }

  get lineList(): Array<ChartOverlayMetadata> {
    return this.overlayMetadataList.filter(
      ({ render }) => render === OverlayRenderType.LINE,
    );
  }

  get scale(): number {
    return this.$stock.state[VuexModuleName.CHART_WRAPPER].metadata.scale;
  }

  // Methods
  // ===================================================================
  removeChartOverlayById(id: string) {
    this.$store.commit(REMOVE_CHART_OVERLAY_BY_ID, id);
  }

  updateActiveOverlay(id: string): void {
    this.$store.commit(SET_ACTIVE_OVERLAY, id);
  }

  resetActiveOverlay(): void {
    this.$store.commit(RESET_ACTIVE_OVERLAY);
  }

  handleTransformed(rect: Rect, id) {
    this.updateOverlayItem(id, {
      path: "position",
      value: {
        x: rect.x,
        y: rect.y,
      },
    });
    this.updateOverlayItem(id, {
      path: "size",
      value: {
        w: rect.w,
        h: rect.h,
      },
    });
    this.updateOverlayItem(id, {
      path: "rotate",
      value: rect.r,
    });
  }

  updateOverlayItem(id: string, { path, value }: { path: string; value: any }) {
    this.$stock.commit(UPDATE_CHART_OVERLAY, { id, path, value });
  }
}
